<script setup lang="ts">
/** Quiz/Rate pill 3182:14919 — badge tint and curve follow the step (1 Not at all … 5 Love it). */
import type { FairQuizScaleStep } from './fairQuizScale.data'

interface FairQuizRatePillProps {
  step: FairQuizScaleStep
  label: string
}

defineProps<FairQuizRatePillProps>()

/** The curve bends from a frown (1) through a line (3) to a smile (5). */
const CURVES: Record<FairQuizScaleStep, string> = {
  1: 'M4.167 13.333C8.056 9.167 11.944 9.167 15.833 13.333',
  2: 'M4.167 12.083C8.056 9.861 11.944 9.861 15.833 12.083',
  3: 'M4.167 10H15.833',
  4: 'M4.167 8.333C8.056 11.111 11.944 11.111 15.833 8.333',
  5: 'M3.333 7.5C7.778 12.778 12.222 12.778 16.667 7.5',
}
</script>

<template>
  <span
    class="fair-quiz-rate-pill"
    :class="`fair-quiz-rate-pill--step-${step}`"
  >
    <span
      class="fair-quiz-rate-pill__badge"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 20 20"
        width="20"
        height="20"
        fill="none"
      >
        <path
          :d="CURVES[step]"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </span>
    <span class="fair-quiz-rate-pill__label">{{ label }}</span>
  </span>
</template>
